import { useTranslation } from "react-i18next";
import styles from "../Drawer.module.scss";
import { useEffect, useState } from "react";
import Slider from "../../Slider/Slider.js";
import PieChart from "../../PieChart/PieChart.js";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";

function DivideBillEqually() {
  const { t } = useTranslation();
  const { remainingAmount, remainingGuests, setVenuesData } =
    useVenuesDataStore();

  const [numberOfParts, setNumberOfParts] = useState(
    Math.max(remainingGuests?.length ?? 1, 1),
  );
  const [highlightCount, setHighlightCount] = useState(1);
  const [isMoreThanEight, setIsMoreThanEight] = useState(false);

  useEffect(() => {
    const guestCount = Math.max(remainingGuests?.length ?? 1, 1);
    setNumberOfParts(guestCount);
  }, [remainingGuests?.length]);

  const pricePerPart =
    numberOfParts > 0 ? remainingAmount / numberOfParts / 100 : 0;

  useEffect(() => {
    setVenuesData({
      selectedAmount: pricePerPart * highlightCount,
      splitMethod: "custom",
    });
  }, [pricePerPart, highlightCount, setVenuesData]);

  const toggleIsMoreThanEight = () => {
    setIsMoreThanEight(!isMoreThanEight);
  };

  const handleNumberOfPartsChange = (
    _event: Event,
    newValue: number | number[],
  ) => {
    if (typeof newValue !== "number") {
      return;
    }
    setNumberOfParts(newValue);
  };

  const handleHighlightCountChange = (
    _event: Event,
    newValue: number | number[],
  ) => {
    if (typeof newValue !== "number") {
      return;
    }
    setHighlightCount(newValue);
  };

  useEffect(() => {
    if (!isMoreThanEight && numberOfParts > 8) {
      setNumberOfParts(8);
    }

    if (!isMoreThanEight && highlightCount > 8) {
      setHighlightCount(8);
    }
  }, [isMoreThanEight, numberOfParts, highlightCount]);

  return (
    <div className={styles.divideBillEquallyContent}>
      <PieChart
        numberOfParts={numberOfParts}
        highlightCount={highlightCount}
        pricePerPart={pricePerPart}
      />
      <Slider
        value={numberOfParts}
        setValue={setNumberOfParts}
        onChange={handleNumberOfPartsChange}
        ariaLabelledby="input-item-number"
        title={t("gradientDrawer.divideBillEqually.firstDescription")}
        max={isMoreThanEight ? 100 : 8}
        moreThanEightQuestion
        toggleIsMoreThanEight={toggleIsMoreThanEight}
        isMoreThanEight={isMoreThanEight}
      />

      <Slider
        value={highlightCount}
        setValue={setHighlightCount}
        onChange={handleHighlightCountChange}
        ariaLabelledby="input-item-people"
        title={t("gradientDrawer.divideBillEqually.secondDescription")}
        max={numberOfParts}
        toggleIsMoreThanEight={toggleIsMoreThanEight}
        isMoreThanEight={isMoreThanEight}
      />
    </div>
  );
}

export default DivideBillEqually;
